import { render } from "./NoticeSearch.vue?vue&type=template&id=5f3dc312&scoped=true"
import script from "./NoticeSearch.vue?vue&type=script&lang=js"
export * from "./NoticeSearch.vue?vue&type=script&lang=js"

import "./NoticeSearch.vue?vue&type=style&index=0&id=5f3dc312&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3dc312"]])

export default __exports__